function getCurrentYear(): string {
    return "2018 - " + new Date().getFullYear().toString();
}

export { getCurrentYear }; 